var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"btn",on:{"click":_vm.down}}),_c('div',{staticClass:"bottomImg"})])])}
var staticRenderFns = []

export { render, staticRenderFns }